module.exports = __webpack_public_path__ + "img/20191004164008360截图20191004163355643.8b101ab4.jpg";